// extracted by mini-css-extract-plugin
module.exports = {"title":"OrderTitle_title__GcXsR","date":"OrderTitle_date__KLAmT","productsCount":"OrderTitle_productsCount__zqJnv"};